import { Component, OnDestroy, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-sorteo-prepas-ganador',
  templateUrl: './sorteo-prepas-ganador.component.html',
  styleUrls: ['./sorteo-prepas-ganador.component.scss']
})
export class SorteoPrepasGanadorComponent implements OnInit, OnDestroy {
  // A diferencia de la lista de participantes (SorteoPrepasComponent),
  // aqui no se lee ningun Excel ni hay buscador: el sorteo ya se celebro
  // y SEGOB solo autoriza publicar un renglon, el del folio ganador.
  //
  // El nombre va como lo pide el permiso: nombre propio completo y las
  // iniciales de cada apellido seguidas de punto
  // ("Mariana Torres Galindo" -> "Mariana T. G.").
  ganador = {
    folio: '001573',
    nombre: 'Mariana T. G.'
  };

  ngOnInit(): void {
    // Dos bloques del layout compartido no se pueden quitar desde el HTML
    // de esta vista, asi que se ocultan al entrar y se restauran al salir
    // para no afectar al resto de las rutas:
    //
    //   #parthers   -> "Nuestra comunidad", vive en el footer.
    //   .sub-menu   -> la barra glass de tres secciones (Inicio / logo
    //                  Magno / Mi Wallet) que el header encima sobre el
    //                  banner. Aqui estorba encima del arte del ganador.
    $('#parthers').hide();
    $('.sub-menu').hide();
  }

  ngOnDestroy(): void {
    $('#parthers').show();
    $('.sub-menu').show();
  }
}
